export const getCustomUrl = (builderId: number) => {
  return `/sale/CP/object_type=2/spec=company/${builderId}/from_developer=1/repres=0/owner=0/pod_snos=0`;
};
